const navigation = ({
  toJSON: () => ({}),
  source: {
    $call: () => ({
      toJSON: () => ({}),
      navigation,
    }),
  },
  parameters: {},
});

export const mockEdm = {
  default: {
    root: {
      identifyEntitySet: () => ({
        toJSON: () => ({}),
        navigation,
      }),
    },
  },
  currentAccount: {
    Campaigns: {
      $withKey: id => ({ AdExtensionAssociations: id }),
    },
  },
};
